module.exports = __webpack_public_path__ + "img/twint.fdf7d1bb.png";